import React from 'react';
import PropTypes from 'prop-types';

import GoBackBtn from '../../common/buttons/GoBackBtn';
import useStyles from './styles';


const QuestionHeader = ({ title, onGoBack }) => {
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <GoBackBtn onClick={onGoBack} />
      <h3 className={classes.modalTitle}>{title}</h3>
    </div>
  );
};


QuestionHeader.defaultProps = {
  title: '',
};

QuestionHeader.propTypes = {
  title: PropTypes.string,
  onGoBack: PropTypes.func.isRequired,
};

export default QuestionHeader;
